import VueRouter from 'vue-router'
import { getToken, setPostLoginRedirect } from '@/helpers/authHelper'
import { store, ROLE_TO_ROLE_STATE } from '@/store'

export const addMiddlewares = (router: VueRouter): void => {
  router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      const token = getToken()
      if (token) {
        // Check each match's meta.allowedRoles and validate that if a route has
        // allowedRoles set, user's role must be present in it
        const allowedRolesMatch = to.matched.every(match => (
          match.meta.allowedRoles
            ? (match.meta.allowedRoles as string[])
              .some(role => store.state[ROLE_TO_ROLE_STATE[role]])
            : true
        ))
        if (allowedRolesMatch) {
          next()
        } else {
          next({ name: 'Home' })
        }
      } else {
        const summitUserId = new URLSearchParams(window.location.search).get('summitUserId')
        let paramString = summitUserId ? '?summitUserId=' + summitUserId : ''
        setPostLoginRedirect(to.path + paramString)
        next({ name: 'Login' })
      }
    } else {
      next()
    }
  })
}
